// redux/slices/ahm.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  se_token: '',
};

const ahmSlice = createSlice({
  name: 'ahm',
  initialState,
  reducers: {
    setSEToken: (state, action) => {
      state.se_token = action.payload;
    },
  },
});

export const { setSEToken } = ahmSlice.actions;

export default ahmSlice.reducer;
